import React, {useEffect} from 'react';
import { Box, Flex, useColorModeValue, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import webSocketStore from "../../Store/webSocketStore";
import { useStore } from "../../Store"

// Motion Box wrapper
const MotionBox = motion(Box);

export const UploadingOverlay = ({loadingMessage}) => {

  const spinnerColor = useColorModeValue('blue.800', 'blue.300');
  const {workingUUID} = useStore((state) => state);
  const uploadStatuses = webSocketStore((state) => state.uploadStatuses);
  let progress = workingUUID.reduce((prevVal, currentVal) => {
    if(uploadStatuses[currentVal]?.progress === 100 && workingUUID.length > 1) {
      prevVal = prevVal + (100/workingUUID.length) 
    } else {
      prevVal = uploadStatuses[currentVal]?.progress
    }
    return prevVal
  }, 0)

  // Lock the scroll when the component is mounted
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Restore scroll when the component unmounts
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <MotionBox
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      bg="rgba(0, 0, 0, 0.6)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={9999}
      aria-live="assertive"
      role="status"
    >
      <Flex flexDirection="column" alignItems="center">
        <span className="loader2"></span>
        <Text mt={2} fontWeight="600" color="white" fontSize="20px" marginTop="5px" textTransform="capitalize">
          <Text as="span" fontSize="22px" fontWeight="600">{progress ? progress : 0}% </Text>
          {loadingMessage}
        </Text>
      </Flex>
    </MotionBox>
  );
};
